import React, { memo } from 'react';
import { Row, Modal, Button, Tab, Nav } from 'react-bootstrap';
import PropTypes from 'prop-types';
import StillageHistory from './StillageHistory';
import StillageAudit from './StillageAudit';
import TrackerLogs from './TrackerLogs';
import FrameDetails from './FrameDetails';

const StillageDetailsModal = ({ showModal, setShowModal, stillageNo, trackerId, jobs }) => {
    const showTrackers = trackerId !== null && trackerId != '';
    return (
        <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            centered
            size="xl"
            animation={false}
            scrollable
            restoreFocus={false}
            enforceFocus={false}
            autoFocus={false}>
            <Modal.Header closeButton>
                <Modal.Title>Stillage Details - {stillageNo || ''}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Tab.Container id="left-tabs-example" defaultActiveKey="history">
                        <Row className="px-5 border-bottom border-secondary border-300">
                            <Nav variant='pills'>
                                <Nav.Item>
                                    <Nav.Link eventKey="history">History</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="audit">Audit</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="frames">Frames/ Boxes</Nav.Link>
                                </Nav.Item>
                                {showTrackers && (
                                    <Nav.Item>
                                        <Nav.Link eventKey="tracker-log">Tracker Log</Nav.Link>
                                    </Nav.Item>
                                )}
                            </Nav>
                        </Row>
                        <Row>
                            <Tab.Content>
                                <Tab.Pane eventKey="history">
                                    <StillageHistory showModal={showModal} setShowModal={setShowModal} stillageNo={stillageNo} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="audit">
                                    <StillageAudit showModal={showModal} setShowModal={setShowModal} stillageNo={stillageNo} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="frames">
                                    <FrameDetails showModal={showModal} setShowModal={setShowModal} jobs={jobs} />
                                </Tab.Pane>
                                {showTrackers && (
                                    <Tab.Pane eventKey="tracker-log">
                                        <TrackerLogs showModal={showModal} setShowModal={setShowModal} trackerId={trackerId} />
                                    </Tab.Pane>
                                )}
                            </Tab.Content>
                        </Row>
                    </Tab.Container>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

StillageDetailsModal.propTypes = {
    showModal: PropTypes.bool,
    setShowModal: PropTypes.func,
    stillageNo: PropTypes.number,
    trackerId: PropTypes.string,
    jobs: PropTypes.string
};

export default memo(StillageDetailsModal);